<template>
  <NuxtLayout
    name="generic"
    header="standardWhite"
    footer="standard"
  >
    <main>
      <FeatureHero
        v-if="data?.heroImage"
        :data
      />

      <AnchorMenuSections
        v-if="data && data.content"
        v-bind="data.content"
        :class="{
          'text-www-color-neutral-medium-dark': true,
        }"
      />

      <CTABanner
        v-if="ctaData"
        :data="ctaData"
      />
    </main>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import { queryFeature } from '~/queries/pages/PageFeature.query';
import type { QueryFeatureResult } from '~/sanity/types';
import { useRefsStore } from '~/composables/refsStore';
import FeatureHero from '~/components/Organisms/FeatureHero/FeatureHero.vue';
import AnchorMenuSections from '~/components/Atoms/AnchorMenuSections/AnchorMenuSections.vue';
import CTABanner from '~/components/Organisms/CTABanner/CTABanner.vue';

const { getResolvedCTABanner } = useRefsStore();

const { path: currentPathname } = useRoute();

const { data } = await useWwwSanityQueryNonNull<QueryFeatureResult>(queryFeature, {
  currentPathname,
});

const ctaData = await getResolvedCTABanner(data.value?.CTABanner?.reference?._ref);

usePageHead({
  _id: data.value?._id,
  description: data.value?.ogDescription || data.value?.description,
  ogImage:
    data.value?.ogImage?.asset || data.value?.cardImage?.asset || data.value?.heroImage?.asset,
  title: data.value?.htmlTitle || data.value?.title,
  excludeFromExternalSearch: data.value?.excludeFromExternalSearch,
  twitterCard: 'summary',
});
</script>
